// extracted by mini-css-extract-plugin
export default {"ContainerTooltip":"Tooltip_ContainerTooltip__rx9G2","TextLink":"Tooltip_TextLink__CMLq4","Text":"Tooltip_Text__56yZ6"};